import React from 'react';
import PropTypes from 'prop-types';
import DivLayout from 'components/sales/divLayout/divLayout';
import localization from 'assets/localization/localization';
import './DivLayoutV2.css';

/** DivLayout hides Description behind a click-to-reveal icon; show value inline in V2 grids. */
const DivLayoutV2PlainField = ({ heading, data }) => (
  <div className="details-list">
    <strong className="data-title">{heading}</strong>
    <span className="data-details">{data != null && data !== '' ? data : localization.na}</span>
  </div>
);

const DivLayoutV2FieldGrid = ({ fields = [], children, className = '' }) => {
  const visibleFields = fields.filter((field) => field?.heading);

  return (
    <div className={`div-layout-v2-field-grid details-listing detail_alignment ${className}`.trim()}>
      {visibleFields.map((field, index) =>
        field.plainValue || field.heading === 'Description' ? (
          <DivLayoutV2PlainField
            key={field.key || `${field.heading}-${index}`}
            heading={field.heading}
            data={field.data}
          />
        ) : (
          <DivLayout
            key={field.key || `${field.heading}-${index}`}
            heading={field.heading}
            data={field.data}
            fullWidth={field.fullWidth}
            status={field.status}
          />
        )
      )}
      {children}
    </div>
  );
};

DivLayoutV2FieldGrid.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      heading: PropTypes.string,
      data: PropTypes.any,
      fullWidth: PropTypes.bool,
      status: PropTypes.bool,
      plainValue: PropTypes.bool,
    })
  ),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default DivLayoutV2FieldGrid;
